

var accordionToggle = Array(document.querySelectorAll('[data-toggle="accordion-toggle"]'))[0];
accordionToggle.forEach(toggle=>{
    let parentItem = toggle.closest('.c-accordion__item');
    let accordion = toggle.closest('.c-accordion');
    let allItems = Array(accordion.querySelectorAll('.c-accordion__item'))[0];
    toggle.addEventListener('click', e=>{
		e.preventDefault();
		e.stopPropagation();
		if (parentItem.classList.contains('open')) {
			parentItem.classList.remove('open');
		}else{
			allItems.forEach(item=>{
				if (!item.classList.contains('blocked')) {
					item.classList.remove('open');
					if (item.querySelector(".c-icons")) {
						if (item.querySelector(".c-icons").classList.contains("icon-less")) {
							item.querySelector(".c-icons").classList.remove("icon-less")
							item.querySelector(".c-icons").classList.add("icon-plus")
						}
					}
				}
			})
			parentItem.classList.add('open');
		}
		if (parentItem.querySelector(".c-icons")) {
			if (parentItem.querySelector(".c-icons").classList.contains("icon-plus")) {
				parentItem.querySelector(".c-icons").classList.remove("icon-plus")
				parentItem.querySelector(".c-icons").classList.add("icon-less")
			} else if (parentItem.querySelector(".c-icons").classList.contains("icon-less")) {
				parentItem.querySelector(".c-icons").classList.remove("icon-less")
				parentItem.querySelector(".c-icons").classList.add("icon-plus")
			}
		}
    })
});

var accordionBlockerToggle = Array(document.querySelectorAll('[data-toggle="block-trigger"]'))[0];
accordionBlockerToggle.forEach(toggle=>{
    let parentItem = toggle.closest('.c-accordion__item');
	toggle.addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		parentItem.classList.toggle('blocked');
	})
});

var subAccordionToggle = Array(document.querySelectorAll('[data-toggle="sub-accordion-toggle"]'))[0];
if (document.getElementsByClassName("c-accordion--responsive").length > 0) {
	if (document.documentElement.clientWidth < 988) {
		var openItem = document.querySelectorAll(".c-accordion--responsive .c-accordion__item");

		openItem.forEach((item) => {
			item.classList.remove("open");
		});
	}
}
if (document.getElementsByClassName("c-accordion--plus").length > 0) {
	var openItem = document.querySelectorAll(".c-accordion--plus .c-accordion__item");
	openItem.forEach((item) => {
		item.classList.remove("open");
	});

}

subAccordionToggle.forEach((toggle) => {
	let parentItem = toggle.closest(".c-sub-accordion__item");
	let accordion = toggle.closest(".c-sub-accordion");
	let allItems = Array(accordion.querySelectorAll(".c-sub-accordion__item"))[0];
	toggle.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (parentItem.classList.contains("open")) {
			parentItem.classList.remove("open");
		} else {
			allItems.forEach((item) => {
				item.classList.remove("open");
			});
			parentItem.classList.add("open");
		}
	});
});
